import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class SearchInput extends React.Component {
  onChange = event => {
    this.props.onChange(event.target.value);
  };

  onClear = () => {
    this.props.onChange("");
  };

  render() {
    return (
      <div className={classNames("product-search", this.props.className)}>
        {this.props.value.length ? (
          <span
            className="fa fa-times-circle search-icon"
            onClick={this.onClear}
          />
        ) : (
          <span className="fa fa-search search-icon" />
        )}
        <input
          placeholder={this.props.placeholder}
          type="text"
          value={this.props.value}
          onChange={this.onChange}
        />
      </div>
    );
  }
}

SearchInput.propTypes = {
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string
};

SearchInput.defaultProps = {
  placeholder: "Search for products"
};

export default SearchInput;
